import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { toast } from 'react-toastify';
import { FaEnvelope, FaLock, FaSignInAlt } from 'react-icons/fa';
import '../styles/Auth.css';

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });

  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const from = location.state?.from || null;

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const validateForm = () => {
    if (!formData.email.trim()) {
      toast.error("Please enter your email");
      return false;
    }
    if (!formData.password.trim()) {
      toast.error("Please enter your password");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    setLoading(true);

    const result = await login(formData.email, formData.password);

    if (result.success) {
      toast.success("Login successful!");

      let redirectPath = "/";

      // If user was redirected from protected route → go back there
      if (from && from !== "/login") {
        redirectPath = from;
      } else {
        // ROLE-BASED DEFAULT REDIRECT
        switch (result.data.role) {
          case "admin":
            redirectPath = "/admin";
            break;
          case "teacher":
            redirectPath = "/teacher";
            break;
          case "student":
            redirectPath = "/student";
            break;
          default:
            redirectPath = "/";
        }
      }

      navigate(redirectPath);
    } else {
      toast.error(result.message);
    }

    setLoading(false);
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <h2><FaSignInAlt /> Login to NIECCE</h2>
            <p>Access your dashboard to continue your journey</p>
          </div>

          <form onSubmit={handleSubmit} className="auth-form">
            <div className="form-group">
              <label><FaEnvelope /> Email Address </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                placeholder="Enter your registered email"
                className="form-input"
              />
            </div>

            <div className="form-group">
              <label><FaLock /> Password </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Enter your password"
                className="form-input"
              />
            </div>

            {/* <div className="form-options">
              <label className="checkbox-label">
                <input type="checkbox" /> Remember me
              </label>
              <Link to="/forgot-password" className="forgot-link">
                Forgot Password?
              </Link>
            </div> */}

            <button
              type="submit"
              className="btn-primary btn-block"
              disabled={loading}
            >
              {loading ? "Logging in..." : "Login"}
            </button>
          </form>

          <div className="auth-footer">
            <p>Are you a Student? <Link to="/apply" className="auth-link">Apply for Admission</Link></p>
            {/* <p>Already applied? <Link to="/signup" className="auth-link">Create Account</Link></p> */}
          </div>

          {/* <div className="role-info">
            <h4>Login Information:</h4>
            <ul>
              <li><strong>Students:</strong> Use email from admission form</li>
              <li><strong>Admin/Teachers:</strong> Use provided credentials</li>
              <li><strong>New Students:</strong> Apply first, then create account</li>
            </ul>
          </div> */}
        </div>

        {/* <div className="auth-side-info">
          <h3>Why Create Account?</h3>
          <ul>
            <li>Access your student dashboard</li>
            <li>View class schedule and materials</li>
            <li>Submit assignments online</li>
            <li>Track your progress</li>
            <li>Get important notifications</li>
            <li>Access Google Classroom</li>
          </ul>
          <div className="cta-section">
            <h4>New to NIECCE?</h4>
            <Link to="/apply" className="btn-secondary">Start Admission Process</Link>
          </div>
        </div> */}
      </div>
    </div>
  );
};

export default Login;
